/**
 * DOM modification tools for the front-end.
 */
H_Tools.dom = (() => {
    /**
     * Executes the same DOM modification to the supplied element that happen to all elements at
     * page load.
     *
     * @param {*} el           An element to perform the DOM modifications to
     * @param {*} aria_current (Optional) Whether to run aria-current modifications
     */
    function modify(el, aria_current = false) {
        H_Tools?.stickyheader?.makeBackwardsFocusable(el);
        H_Tools?.dictionary?.enableDictionaryEntries(el);
        H_Tools?.show_more?.enableShowMoreElements(el);
        H_Tools?.accordions?.enableAccordions(el);
        H_Tools?.links?.modifyLinks(el);

        if (aria_current) {
            H_Tools?.links?.addAriaCurrent(el);
        }
    }

    // Return an object to expose variables and functions
    return {
        modify: modify,
    };
})();
